import { React, useEffect } from 'react';

import Table from 'react-bootstrap/Table';
import SongListSongCriteria from './SongListSongCriteria';

export default function SongListTable(props) {

    return(
        <div style={{'height': '100%', 'max-height': '100%', 'overflow-y': 'auto'}}>
        <Table striped bordered hover size="sm">
            <thead>
                <tr>
                    <th>Catalog</th>
                    <th>Title</th>
                    <th>Artist</th>
                    <th>Tags</th>
                </tr>
            </thead>
            <tbody>
                {props.songs.map((song) => (
                    <tr>
                        <td>{song.catalog_uuid.substr(song.catalog_uuid.length - 6)}</td>
                        <td>{song.title}</td>
                        <td>{song.artist}</td>
                        <td>{song.tags.join(',')}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
        </div>
    )
}